import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { showToast } from "src/utils/showToaster";
import GroupForm from "../Layouts/GroupForm";
import { GroupFormValues } from "src/models/Group.model";
import { useAddGroupMutation } from "src/services/GroupService";

type Props = {
  onClose: () => void;
};

const AddGroupWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const initialValues: GroupFormValues = {
    groupName: "",
    order: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    groupName: string().required("Please enter Group name"),
    order: string().required("Please enter order"),
  });

  const [addGroup] = useAddGroupMutation();

  // Handle Submit
  const handleSubmit = (
    values: GroupFormValues,
    { setSubmitting, resetForm }: FormikHelpers<GroupFormValues>
  ) => {
    const payload = {
      groupName: values.groupName,
      order: Number(values.order),
    };
    addGroup(payload).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <GroupForm
              formikProps={formikProps}
              onClose={onClose}
              formType="ADD"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddGroupWrapper;
